import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';

/**
 * @param {Object} props - The properties for the ConfigSection component.
 * @param {string} props.title - The title of the section.
 * @param {string} props.shephardId - Shephard string value to attach to the config column
 * @param {React.ReactNode} props.description - The description of the section.
 * @param {'default' | "card"} props.type - The type of the section.
 * @param {string} props.className - Additional class names for the section.
 * @param {string} props.contentClassName - Additional class names for the content.
 * @param {string} props.columnClassName - Additional class names for the columns.
 * @param {string} props.descriptionClassName - Additional class names for the description.
 * @param {React.ReactNode} props.children - The content of the section.
 */
export default function ConfigSection({
  title = '',
  description = '',
  shephardId = null,
  type = 'default',
  className = '',
  titleClassName = '',
  contentClassName = '',
  columnClassName = '',
  descriptionClassName = '',
  children = null
}) {
  return (
    <section className={cn(styles.container, className)}>
      <If test={title}>
        <h5 className={cn(styles.title, titleClassName)}>{title}</h5>
      </If>
      <UiKit.Grid
        templateColumns="1fr 1fr"
        gap={40}
        className={cn(styles.content, contentClassName)}
      >
        <If test={children}>
          <div
            data-type={type}
            data-shepherd={shephardId}
            className={cn(styles.column, styles.leftColumn, columnClassName)}
          >
            {children}
          </div>
        </If>
        <If test={description}>
          <div
            className={cn(styles.column, styles.rightColumn, columnClassName)}
          >
            <div className={cn(styles.description, descriptionClassName)}>
              {description}
            </div>
          </div>
        </If>
      </UiKit.Grid>
    </section>
  );
}
